import React, { useEffect } from 'react';

/** Lightweight “sticker” burst — no Lottie dep; CSS orbits like TGS reaction. */
export default function PassStickerBurst({ show, onDone }) {
  useEffect(() => {
    if (!show) return undefined;
    const t = window.setTimeout(() => onDone?.(), 1400);
    return () => clearTimeout(t);
  }, [show, onDone]);

  if (!show) return null;

  return (
    <div className="pass-sticker-burst" aria-hidden>
      <div className="pass-sticker-core">⭐</div>
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <i key={i} className={`pass-sticker-orb o${i}`} />
      ))}
    </div>
  );
}
